export const SET_HAS_UNREAD_MESSAGES = 'feature/header/SET_HAS_UNREAD_MESSAGES';
export const SET_MENU_OPEN = 'feature/header/SET_MENU_OPEN';
export const SET_MAKE_MODEL_SEARCH_ACTIVE =
  'feature/header/SET_MAKE_MODEL_SEARCH_ACTIVE';

export const CLICK_SYI_LINK = 'feature/header/CLICK_SYI_LINK';
